/*globals globalThis */
var jsPDF = require("jspdf");
jsPDF = jsPDF.API ? jsPDF : jsPDF.default;
var fontFix = require("./font-fix");
var colorUtil = require("./colors");
var PDFBlock = require("./block");
var PDFAbsolute = require("./absolute");
var PDFHr = require("./hr");
var PDFText = require("./text");
var PDFImage = require("./image");
var PDFCanvas = require("./canvas");
var PDFColumns = require("./columns");
var PDFTable = require("./table");
var PDFTableCell = require("./table-cell");
var PDFInlineBlock = require("./inline-block");
var PDFListItem = require("./list-item");
var PDFSection = require("./section");
var pageSizes = require("./pageSizes");
var a11y = require("./a11y");
var cursorStack = (globalThis.cursorStack = []);
function patchDraw(C) {
    var p = C.prototype;
    var draw = p.draw;
    p.draw = function (cursor) {
        cursorStack.push({ element: this, cursor: cursor });
        var r = draw.apply(this, arguments);
        cursorStack.pop();
        return r;
    };
}
[
    PDFBlock,
    PDFAbsolute,
    PDFHr,
    PDFText,
    PDFImage,
    PDFCanvas,
    PDFColumns,
    PDFTable,
    PDFTableCell,
    PDFInlineBlock,
    PDFListItem,
    PDFSection,
].forEach(patchDraw);
(function (jsPDFAPI) {
    jsPDFAPI.pushState = function () {
        this.internal.write("q");
    };
    jsPDFAPI.popState = function () {
        this.internal.write("Q");
    };
    var fillOpacityStates = {};
    jsPDFAPI.setFillOpacity = function (v) {
        v = Number(v);
        if (isNaN(v))
            throw new Error("Opacity must be a number");
        if (!fillOpacityStates[v]) {
            fillOpacityStates[v] = new this.GState({ opacity: v });
        }
        this.setGState(fillOpacityStates[v]);
        // var stateKey = this.internal.addExtGState({
        //     ca: Math.max(0, Math.min(1, v))
        // });
        // this.internal.write("/" + stateKey + " gs");
    };
    var strokeOpacityStates = {};
    jsPDFAPI.setStrokeOpacity = function (v) {
        v = Number(v);
        if (isNaN(v))
            throw new Error("Opacity must be a number");
        if (!strokeOpacityStates[v]) {
            strokeOpacityStates[v] = new this.GState({ "stroke-opacity": v });
        }
        this.setGState(fillOpacityStates[v]);
        // var stateKey = this.internal.addExtGState({
        //     CA: Math.max(0, Math.min(1, v))
        // });
        // this.internal.write("/" + stateKey + " gs");
    };
})(jsPDF.API);
function PDF(options) {
    options = options || {};
    var orientation = "portrait";
    if (typeof options.orientation === "string" && options.orientation.toLowerCase() === "landscape")
        orientation = "landscape";
    var format = "letter";
    if (Array.isArray(options.format) || typeof options.format === "string")
        format = options.format;
    this.doc =
        options.doc ||
            new jsPDF({
                orientation: orientation,
                unit: "pt",
                format: format,
                compress: options.compress || false,
            });
    fontFix(this.doc);
    this.cursor = {
        x: 0,
        y: 0,
        width: 612,
        height: 792,
        doc: this.doc,
    };
}
PDF.colors = colorUtil.defaults;
PDF.addColors = function (newColors) {
    colorUtil.extendColors(newColors);
};
PDF.prototype.draw = function (obj) {
    //if (typeof (obj.width) !== 'number' || typeof (obj.height) !== 'number') this.calc(obj);
    //if (typeof (obj) === 'object' && typeof (obj.draw) === 'function') obj.draw.call(this);
    if (typeof obj === "object" && typeof obj.draw === "function")
        obj.draw(this.cursor);
};
// PDF.prototype.calc = function (obj) {
//     var spec;
//     if (typeof (obj) === 'object' && typeof (obj.calc) === 'function') spec = obj.calc.call(this);
//
//     obj.width = spec.width;
//     obj.height = spec.height;
// };
PDF.block = PDF.prototype.block = function (options, children) {
    return new PDFBlock(options, children);
};
PDF.absolute = PDF.prototype.absolute = function (options, children) {
    return new PDFAbsolute(options, children);
};
PDF.inlineBlock = PDF.prototype.inlineBlock = function (options, children) {
    return new PDFInlineBlock(options, children);
};
PDF.listItem = PDF.prototype.listItem = function (options, children) {
    return new PDFListItem(options, children);
};
PDF.text = PDF.prototype.text = function (options, text) {
    return new PDFText(options, text);
};
PDF.hr = PDF.prototype.hr = function (color, height) {
    return new PDFHr(color, height);
};
PDF.image = PDF.prototype.image = function (options) {
    return new PDFImage(options);
};
PDF.canvas = PDF.prototype.canvas = function (width, height, alt, drawFunc) {
    return new PDFCanvas(width, height, alt, drawFunc);
};
PDF.columns = PDF.prototype.columns = function (options, children) {
    return new PDFColumns(options, children);
};
PDF.table = PDF.prototype.table = function (options, rows) {
    return new PDFTable(options, rows);
};
PDF.tableCell = PDF.prototype.tableCell = function (options, children) {
    return new PDFTableCell(options, children);
};
PDF.td = PDF.prototype.td = PDF.tableCell;
PDF.section = PDF.prototype.section = function (options, template, content) {
    return new PDFSection(options, template, content);
};
PDF.sectionContent = PDF.prototype.sectionContent = function (options) {
    return new PDFSection.SectionContent(options);
};
PDF.pageSizes = pageSizes;
PDF.a11y = PDF.prototype.a11y = a11y;
PDF.setDefaultFont = PDF.prototype.setDefaultFont = PDFText.setDefaultFont;
PDF.saveMethod = function () {
    return "js";
};
module.exports = PDF;
//# sourceMappingURL=module.js.map